import { useMemo } from 'react';

import { LoyaltyOffer } from 'state/loyalty/types';

import { useGetCmsAndLoyaltyOffers } from './use-get-cms-and-loyalty-offers';
import { useReduceOffers } from './use-offers-reducer';
import { getSelectedIncentive } from './utils';

export const useGetIncentive = ({ loyaltyEngineId }: { loyaltyEngineId: string }) => {
  const {
    cmsOffers,
    cmsOfferGroups,
    personalizedOffers,
    baseOffers,
    offersLoading,
    refreshOffersLoading,
  } = useGetCmsAndLoyaltyOffers();

  const { offers, offersInCart, reductionLoading } = useReduceOffers({
    cmsOffers,
    cmsOfferGroups,
    personalizedOffers,
    baseOffers,
    offersLoading,
  });

  const selectedIncentive:
    | (LoyaltyOffer & { isUnavailable?: boolean })
    | undefined = useMemo(() => {
    let selectedIncentive = getSelectedIncentive(loyaltyEngineId, offers, offersInCart);

    // If the incentive isn't in the offers list, we search in the cmsOfferGroups array.
    if (!selectedIncentive && loyaltyEngineId && cmsOfferGroups.length) {
      for (const group of cmsOfferGroups) {
        const incentive = group.offers?.find(offer => offer?.loyaltyEngineId === loyaltyEngineId);
        if (incentive) {
          selectedIncentive = incentive;
          break;
        }
      }
    }

    // If the incentive isn't in the offers list, we search in the cmsOffers array.
    // This incentive will be unavailable.
    if (!selectedIncentive && loyaltyEngineId && cmsOffers.length) {
      selectedIncentive = getSelectedIncentive(loyaltyEngineId, cmsOffers, []);

      return selectedIncentive ? { ...selectedIncentive, isUnavailable: true } : undefined;
    }

    return selectedIncentive;
  }, [loyaltyEngineId, offers, offersInCart, cmsOffers, cmsOfferGroups]);

  const isIncentivesLoading =
    offersLoading || reductionLoading || refreshOffersLoading || !offers || offers?.length === 0;

  return { selectedIncentive, isIncentivesLoading };
};
